import { SortingState } from "@tanstack/react-table"

export default function getOrderingFromSortingState(sortingState: SortingState) {
    return sortingState.map((columnSort) => `${columnSort.desc ? "-" : ""}${columnSort.id}`).join(",")
}
